// import React, { useEffect, useState } from "react";
// import Footer from "../footer/footer";
// import Navbar from "../navbar/navbar";
// import Sidebar from "../sidebar/sidebar";
// import SectionHeader from "../sectionHeader/sectionHeader";
// import Indexer from "../router/router";
// import { getAppUser, getLanguages, isNecessary } from "../../api/api";
// import { UserLang, UserStore } from "../../store/userStore";
// import { NecStore } from "../../store/necStore";
// import Loader from "../loader/loader";

// const Dashboard = (props) => {
//   const [loading, setLoading] = useState(false);
//   const [floading, setFLoading] = useState(false);
//   const [name, setName] = useState("");
//   const [data, setData] = useState(null);
//   const [details, setDetails] = useState([]);
//   const [lan, setLan] = useState([]);
//   const lanPic = [
//     "ar",
//     "arc",
//     "dv",
//     "fa",
//     "ha",
//     "he",
//     "khw",
//     "ks",
//     "ku",
//     "ps",
//     "ur",
//     "yi",
//   ];
//   useEffect(() => {
//     const getLanguage = async () => {
//       setLoading(true);
//       /* eslint-disable no-unused-vars */
//       try {
//         const appl = await getLanguages();
//
//         const newArray = appl.data;
//         lanPic.map(
//           (image, index) => setLan(appl.data.languages[0].languageid)

//           //
//           //
//           //
//         );
//         setLoading(false);
//
//       } catch (error) {
//
//         // toastr.error("Unable to Load Data", 'Error');
//         setLoading(false);
//       }
//
//       for (var i = 0; i < lanPic.length; i++) {
//         if (lan === lanPic[i]) {
//           var a = true;
//
//
//         }
//       }

//       UserLang.update((s) => {
//         s.lan = a === true ? "rtl" : "ltr";
//
//       });
//       /* eslint-disable no-unused-vars */
//     };
//     getLanguage();

//     const appDetails = async () => {
//       setFLoading(true);
//       /* eslint-disable no-unused-vars */
//       const result = await isNecessary().then(
//         (result) => {
//
//           setDetails(result.data);
//           NecStore.update((s) => {
//             s.setting = result.data;
//           });
//
//           setFLoading(false);
//         },
//         (error) => {
//
//           setFLoading(false);
//         }
//       );
//       /* eslint-disable no-unused-vars */
//     };

//     appDetails();
//     const userDetail = async () => {
//       setLoading(true);
//       /* eslint-disable no-unused-vars */
//       const result = await getAppUser().then(
//         (result) => {
//
//           setLoading(false);
//           UserStore.update((s) => {
//             s.user = result.data;
//           });
//           setData(result.data);
//           setName(result.data.name);
//           return result;
//         },
//         (error) => {
//
//           props.history.push("/login");
//           setLoading(false);
//         }
//       );

//       /* eslint-disable no-unused-vars */
//     };
//     userDetail();
//     //eslint-disable-next-line
//   }, [props.history, lan]);

//
//   if (!loading && !floading) {
//     return (
//       <div className="wrapper">
//         <Navbar name={data} {...props} />
//         <Sidebar
//           name={name}
//           appname={details}
//           data={data}
//           loader={loading}
//           {...props}
//         />
//         <div className="content-wrapper" style={{ minheight: "640px" }}>
//           <SectionHeader {...props}></SectionHeader>
//           <Indexer name={data} {...props}></Indexer>
//         </div>

//         <Footer />
//       </div>
//     );
//   } else {
//     return <Loader></Loader>;
//   }
// };

// export default Dashboard;

// import React, { useEffect, useState } from "react";
// import Footer from "../footer/footer";
// import Navbar from "../navbar/navbar";
// import Sidebar from "../sidebar/sidebar";
// import SectionHeader from "../sectionHeader/sectionHeader";
// import Indexer from "../router/router";
// import { getAppUser, getLanguages, isNecessary } from "../../api/api";
// import { UserLang, UserStore } from "../../store/userStore";
// import { NecStore } from "../../store/necStore";
// import Loader from "../loader/loader";

// const Dashboard = (props) => {
//   const [loading, setLoading] = useState(false);
//   const [floading, setFLoading] = useState(false);
//   const [name, setName] = useState("");
//   const [data, setData] = useState(null);
//   const [details, setDetails] = useState([]);
//   const [lan, setLan] = useState(null); // Initially set to null
//   const lanPic = [
//     "ar",
//     "arc",
//     "dv",
//     "fa",
//     "ha",
//     "he",
//     "khw",
//     "ks",
//     "ku",
//     "ps",
//     "ur",
//     "yi",
//   ];

//   useEffect(() => {
//     const getLanguage = async () => {
//       setLoading(true);
//       try {
//         const appl = await getLanguages();
//
//         const languages = appl.data?.languages; // Safely access languages array

//         // Make sure languages array is not empty
//         if (languages && languages.length > 0) {
//           setLan(languages[0].languageid); // Assuming languages[0] exists
//         } else {
//
//         }

//         setLoading(false);
//       } catch (error) {
//
//         setLoading(false);
//       }
//     };

//     getLanguage();

//     const appDetails = async () => {
//       setFLoading(true);
//       try {
//         const result = await isNecessary();
//
//         setDetails(result.data);
//         NecStore.update((s) => {
//           s.setting = result.data;
//         });
//         setFLoading(false);
//       } catch (error) {
//
//         setFLoading(false);
//       }
//     };

//     appDetails();

//     const userDetail = async () => {
//       setLoading(true);
//       try {
//         const result = await getAppUser();
//
//         setLoading(false);
//         UserStore.update((s) => {
//           s.user = result.data;
//         });
//         setData(result.data);
//         setName(result.data.name);
//       } catch (error) {
//
//         props.history.push("/login");
//         setLoading(false);
//       }
//     };

//     userDetail();

//     // eslint-disable-next-line
//   }, [props.history]);

//   // Handle lan state change
//   useEffect(() => {
//     if (lan !== null) {
//       let a = false;
//       for (let i = 0; i < lanPic.length; i++) {
//         if (lan === lanPic[i]) {
//           a = true;
//
//
//         }
//       }

//       UserLang.update((s) => {
//         s.lan = a ? "rtl" : "ltr";
//
//       });
//     }
//   }, [lan]); // Only run this effect if 'lan' is updated

//   if (!loading && !floading) {
//     return (
//       <div className="wrapper">
//         <Navbar name={data} {...props} />
//         <Sidebar
//           name={name}
//           appname={details}
//           data={data}
//           loader={loading}
//           {...props}
//         />
//         <div className="content-wrapper" style={{ minHeight: "640px" }}>
//           <SectionHeader {...props}></SectionHeader>
//           <Indexer name={data} {...props}></Indexer>
//         </div>
//         <Footer />
//       </div>
//     );
//   } else {
//     return <Loader />;
//   }
// };

// export default Dashboard;
import React, { useEffect, useState } from "react";
import Footer from "../footer/footer";
import Navbar from "../navbar/navbar";
import Sidebar from "../sidebar/sidebar";
import SectionHeader from "../sectionHeader/sectionHeader";
import Indexer from "../router/router";
import { getAppUser, getLanguages, isNecessary } from "../../api/api";
import { UserLang, UserStore } from "../../store/userStore";
import { NecStore } from "../../store/necStore";
import Loader from "../loader/loader";

const Dashboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [floading, setFLoading] = useState(false);
  const [name, setName] = useState("");
  const [data, setData] = useState(null);
  const [details, setDetails] = useState([]);
  const [lan, setLan] = useState("");
  const lanPic = [
    "ar",
    "arc",
    "dv",
    "fa",
    "ha",
    "he",
    "khw",
    "ks",
    "ku",
    "ps",
    "ur",
    "yi",
  ];

  useEffect(() => {
    const getLanguage = async () => {
      setLoading(true);
      try {
        const appl = await getLanguages();

        // Assuming that appl.data.languages is an array, you might want to check all languages
        const languageId = appl.data.languages[0]?.languageid;
        setLan(languageId);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getLanguage();

    const appDetails = async () => {
      setFLoading(true);
      try {
        const result = await isNecessary();

        setDetails(result.data);
        NecStore.update((s) => {
          s.setting = result.data;
        });
        setFLoading(false);
      } catch (error) {
        setFLoading(false);
      }
    };

    appDetails();

    const userDetail = async () => {
      setLoading(true);
      try {
        const result = await getAppUser();

        setLoading(false);
        UserStore.update((s) => {
          s.user = result.data;
        });
        setData(result.data);
        setName(result.data.name);
      } catch (error) {
        props.history.push("/login");
        setLoading(false);
      }
    };

    userDetail();
  }, [props.history]);

  // Determine if the layout should be RTL or LTR
  useEffect(() => {
    if (lanPic.includes(lan)) {
      UserLang.update((s) => {
        s.lan = "rtl";
      });
    } else {
      UserLang.update((s) => {
        s.lan = "ltr";
      });
    }
  }, [lan]);

  if (!loading && !floading) {
    return (
      <div className="wrapper">
        <Navbar name={data} {...props} />
        <Sidebar
          name={name}
          appname={details}
          data={data}
          loader={loading}
          {...props}
        />
        <div className="content-wrapper" style={{ minHeight: "640px" }}>
          <SectionHeader {...props} />
          <Indexer name={data} {...props} />
        </div>
        <Footer />
      </div>
    );
  } else {
    return <Loader />;
  }
};

export default Dashboard;
